/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Kind_Hero_SlideInputs */

const vi_shop_home_kind_hero_slide = /** @type {(inputs: Shop_Home_Kind_Hero_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slider đầu trang`)
};

/**

* @param {Shop_Home_Kind_Hero_SlideInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_kind_hero_slide = /** @type {((inputs?: Shop_Home_Kind_Hero_SlideInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Kind_Hero_SlideInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_kind_hero_slide(inputs)
});